import { render } from "./OpenEndedResponses.vue?vue&type=template&id=388715e4"
import script from "./OpenEndedResponses.vue?vue&type=script&lang=js"
export * from "./OpenEndedResponses.vue?vue&type=script&lang=js"

import exportComponent from "E:\\Dev\\Univ\\vueQuizzly\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__